import { AppEventTokenEnum } from "@/utilities/capacitorLogic";

import { useFromHomeEntry } from "./useFromHomeEntry";
import { useSendAppEvent } from "./useSendAppEvent";

type AppEventParams = { [key: string]: string | number | boolean };

// 投資スタイル診断フローの到達計測。登録導線のファネル数値を測るためのものなので、
// ホームのミニ表示から入った場合は送らない（既存ユーザーの再訪で到達率が水増しされるのを防ぐ）。
// 入口の判定は履歴エントリの state（useFromHomeEntry）なので、エントリが生きている限り値は変わらず、
// 旧実装のような「クリアで判定が反転する前に useState で凍結する」工夫は不要。
export const useInvestmentStyleFunnelEvent = (
  token: AppEventTokenEnum | undefined,
  params?: AppEventParams
): void => {
  const fromHome = useFromHomeEntry();
  useSendAppEvent(fromHome ? undefined : token, params);
};
